import { Card } from '@blueprintjs/core';
import styled, { css } from 'styled-components';

export const StyledCard = styled(Card)<{ $borderColor: string }>`
    ${({ $borderColor }) => css`
        border-bottom: 2px solid ${$borderColor};
    `}
`;
